import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { cn } from '../../utils/cn';
import { SelectScrollUpButton } from './select-scroll-up-button';
import { SelectScrollDownButton } from './select-scroll-down-button';

export function SelectContent({
    className,
    children,
    position = 'popper',
    align = 'center',
    borderless = false,
    withOverlay = false,
    ...props
}: React.ComponentProps<typeof SelectPrimitive.Content> & {
    borderless?: boolean;
    withOverlay?: boolean;
}) {
    const contentId = React.useId();

    return (
        <SelectPrimitive.Portal>
            <SelectPrimitive.Content
                data-select-content-id={contentId}
                data-select-with-overlay={withOverlay ? 'true' : 'false'}
                data-slot="select-content"
                className={cn(
                    'max-h-(--radix-select-content-available-height) origin-(--radix-select-content-transform-origin) data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-popover min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover text-popover-foreground shadow-md',
                    position === 'popper' &&
                        'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1',
                    className,
                )}
                position={position}
                align={align}
                {...props}
            >
                <SelectScrollUpButton />
                <SelectPrimitive.Viewport
                    className={cn(
                        borderless ? 'p-0' : 'p-1',
                        position === 'popper' &&
                            'min-h-(--radix-select-trigger-height) min-w-(--radix-select-trigger-width) w-full scroll-my-1',
                    )}
                >
                    {children}
                </SelectPrimitive.Viewport>
                <SelectScrollDownButton />
            </SelectPrimitive.Content>
        </SelectPrimitive.Portal>
    );
}
